webpackJsonp([1],{

/***/ "4fwg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0faf3d6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Oz8N");
function injectStyle (ssrContext) {
  __webpack_require__("4fwg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0faf3d6e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css__ = __webpack_require__("q8zI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "Oz8N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', [_vm._v("\n      Markdown Table Generator\n    ")]), _vm._v(" "), _c('el-radio-group', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.changeLayout
    },
    model: {
      value: (_vm.labelPosition),
      callback: function($$v) {
        _vm.labelPosition = $$v
      },
      expression: "labelPosition"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "left"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "center"
    }
  }, [_vm._v("Center")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "right"
    }
  }, [_vm._v("Right")])], 1), _vm._v(" "), _c('div', [_c('el-input-number', {
    attrs: {
      "min": 2,
      "size": "small"
    },
    on: {
      "change": _vm.changeRow
    },
    model: {
      value: (_vm.rowNum),
      callback: function($$v) {
        _vm.rowNum = $$v
      },
      expression: "rowNum"
    }
  }), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 2,
      "size": "small"
    },
    on: {
      "change": _vm.changeCol
    },
    model: {
      value: (_vm.colNum),
      callback: function($$v) {
        _vm.colNum = $$v
      },
      expression: "colNum"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "small"
    },
    on: {
      "click": _vm.clearTable
    }
  }, [_vm._v("Clear Table")])], 1), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "small"
    },
    on: {
      "click": _vm.insertColumnLeft
    }
  }, [_vm._v("Insert Column to the Left")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "small"
    },
    on: {
      "click": _vm.insertColumnRight
    }
  }, [_vm._v("Insert Column to the Right")])], 1), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    staticClass: "outline header"
  }), _vm._v(" "), _vm._l((_vm.rowNum), function(r) {
    return _c('td', {
      staticClass: "outline header"
    })
  })], 2), _vm._v(" "), _vm._l((_vm.currentValue), function(cells, i) {
    return _c('tr', [_c('td', {
      staticClass: "outline"
    }), _vm._v(" "), _vm._l((cells), function(cell, j) {
      return _c('td', {
        class: {
          active: cell.select
        },
        on: {
          "click": function($event) {
            _vm.selectValue(cell, i, j)
          },
          "keyup": function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
            _vm.submit(cell)
          }
        }
      }, [(!cell.edit) ? _c('div', {
        staticClass: "display",
        domProps: {
          "textContent": _vm._s(cell.text)
        },
        on: {
          "click": function($event) {
            cell.edit = true
          }
        }
      }) : _vm._e(), _vm._v(" "), (cell.edit) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cell.text),
          expression: "cell.text"
        }, {
          name: "focus",
          rawName: "v-focus"
        }],
        ref: "textInput",
        refInFor: true,
        attrs: {
          "onfocus": "this.style.width = ((this.value.length + 1) * 8) + 'px';",
          "type": "text"
        },
        domProps: {
          "value": (cell.text)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            cell.text = $event.target.value
          }, _vm.inputCell],
          "blur": function($event) {
            cell.edit = false
          },
          "keydown": function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
            _vm.nextCell($event)
          }
        }
      }) : _vm._e()])
    })], 2)
  })], 2), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "primary",
      "icon": "document"
    },
    on: {
      "click": _vm.copyToClipBoard
    }
  }, [_vm._v("Copy to ClipBoard")]), _vm._v(" "), _c('div', [_c('pre', [_vm._v("        "), _c('code', {
    attrs: {
      "id": "mdArea"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.generateMdTable) + "\n        ")]), _vm._v("\n      ")])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__("qSdX");




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */]
  }]
}));

/***/ }),

/***/ "exPH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iZUp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_vm._v("Essential Links")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Ecosystem")]), _vm._v(" "), _vm._m(1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Core Docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://forum.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Forum")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://chat.vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Community Chat")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/vuejs",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuejs-templates.github.io/webpack/",
      "target": "_blank"
    }
  }, [_vm._v("Docs for This Template")])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://router.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-router")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vuex.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vuex")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://vue-loader.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("vue-loader")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/vuejs/awesome-vue",
      "target": "_blank"
    }
  }, [_vm._v("awesome-vue")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pMZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});

/***/ }),

/***/ "q8zI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qSdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__("pMZz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42216f61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__("iZUp");
function injectStyle (ssrContext) {
  __webpack_require__("exPH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42216f61"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42216f61_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable__ = __webpack_require__("DAYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuedraggable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var focus = {
  inserted: function inserted(el) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].nextTick(function () {
      el.focus();
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_1_vuedraggable___default.a
  },
  data: function data() {
    return {
      labelPosition: 'center',
      beforeRowNum: 3, // 増減に対応するために必要
      beforeColNum: 3, // 増減に対応するために必要
      rowNum: 3,
      colNum: 3,
      curSelectRowNum: 0, // -1は選択してない状態とする
      curSelectColNum: 0, // -1は選択してない状態とする
      cellSelectStatus: 0, // 0,1,2を取る。 0: 未選択, 1: 選択中, 2: 編集中
      values: [[{ text: '', edit: false, select: false }, { text: '', edit: false, select: false }, { text: '', edit: false, select: false }], [{ text: '', edit: false, select: false }, { text: '', edit: false, select: false }, { text: '', edit: false, select: false }], [{ text: '', edit: false, select: false }, { text: '', edit: false, select: false }, { text: '', edit: false, select: false }]],
      valuesCache: []
    };
  },

  computed: {
    currentValue: function currentValue() {
      return this.values;
    },
    generateMdTable: function generateMdTable() {
      var all = '\n';

      // タイトル
      var title = '|'; // 左端
      for (var i = 0; i < this.values[0].length; i++) {
        title += ' ' + this.values[0][i].text + ' |';
      }

      all += title + '\n';

      // ２段目
      var arrangement = this.labelPosition === 'left' ? '|:' : '|';
      for (var j = 0; j < this.values[0].length; j++) {
        switch (this.labelPosition) {
          case 'left':
            arrangement += j > 0 ? ':' : '';
            arrangement += '-'.repeat(this.values[0][j].text.length + 1) + '--|';
            break;
          case 'center':
            arrangement += '-'.repeat(this.values[0][j].text.length + 1) + '--|';
            break;
          case 'right':
            arrangement += '-'.repeat(this.values[0][j].text.length + 1) + '--:|';
            break;
        }
      }

      all += arrangement + '\n';

      // それ以降
      for (var k = 1; k < this.values.length; k++) {
        var row = '|';
        for (var l = 0; l < this.values[k].length; l++) {
          row += ' ' + this.values[k][l].text + ' |';
        }
        all += row + '\n';
      }

      all += '';
      return all;
    }
  },
  methods: {
    changeLayout: function changeLayout() {
      console.log(this.labelPosition);
    },
    changeRow: function changeRow(val) {
      // 行追加
      this.beforeRowNum = this.rowNum;
      if (val > this.beforeRowNum) {
        for (var i = 0; i < val - this.beforeRowNum; i++) {
          var newRow = [];
          for (var j = 0; j < this.colNum; j++) {
            newRow.push({ text: '', edit: false, select: false });
          }
          this.values.push(newRow);
        }
      } else {
        for (var k = 0; k < this.beforeRowNum - val; k++) {
          this.values.pop();
        }
      }
    },
    changeCol: function changeCol(val) {
      var _this = this;

      // 列追加
      this.beforeColNum = this.colNum;
      if (val > this.beforeColNum) {
        // 列を増やす場合
        this.values.forEach(function (row) {
          for (var i = 0; i < val - _this.beforeColNum; i++) {
            row.push({ text: '', edit: false, select: false });
          }
        });
      } else {
        // 列を減らす場合
        if (this.curSelectColNum === val) {
          // 現在選択中のcellが表示から消える場合には、右端に選択中を合わせる
          this.curSelectColNum -= 1;
          this.values[this.curSelectRowNum][val - 1].select = true;
        }

        this.values.forEach(function (row) {
          for (var j = 0; j < _this.beforeColNum - val; j++) {
            row.pop();
          }
        });
      }
    },
    importCSV: function importCSV(filePath) {
      console.log(filePath);
      var req = new XMLHttpRequest(); // HTTPでファイルを読み込むためのXMLHttpRrequestオブジェクトを生成
      req.open('get', filePath, true); // アクセスするファイルを指定
      req.send(null); // HTTPリクエストの発行

      req.onload = function () {
        console.log(req.responseText); // 渡されるのは読み込んだCSVデータ
      };
    },
    clearTable: function clearTable() {
      this.values.forEach(function (row) {
        row.map(function (cell) {
          cell.text = '';
          cell.edit = false;
        });
      });
    },
    insertColumnLeft: function insertColumnLeft() {
      var _this2 = this;

      this.values.forEach(function (row) {
        if (_this2.curSelectColNum === 0) {
          // 左端を選択しているときは
          row.unshift({ text: '', edit: false, select: false });
        } else {
          row.splice(_this2.curSelectColNum, 0, { text: '', edit: false, select: false });
        }
      });
      this.curSelectColNum++; // 追加によるselectの位置の整合性をとる
      this.colNum++;
    },
    insertColumnRight: function insertColumnRight() {
      var _this3 = this;

      this.values.forEach(function (row) {
        row.splice(_this3.curSelectColNum + 1, 0, { text: '', edit: false, select: false });
      });
      this.colNum++;
    },
    nextCell: function nextCell(event) {// 次のセルへフォーカス
      // console.log(this.values[0][1].edit)
      // this.values[0][1].edit = false
      // console.log(this.values[0][1].edit)
      // this.values[0][2].edit = true
    },
    selectValue: function selectValue(cell, i, j) {
      if (i !== this.curSelectRowNum || j !== this.curSelectColNum) {
        // 選択中だが、別のcellを選んだ場合
        this.cellSelectStatus = 0;
        this.values[this.curSelectRowNum][this.curSelectColNum].select = false; // もともと選択してたものは色を戻す
      }

      if (this.cellSelectStatus === 0) {
        // 未選択の時には、curSelectRowNum, this.curSelectColNumに値を入れて保持
        this.curSelectRowNum = i;
        this.curSelectColNum = j;
        this.cellSelectStatus++; // 1にする
        cell.select = true;
        cell.edit = false;
        return;
      }

      if (i === this.curSelectRowNum && j === this.curSelectColNum) {
        // どのcellか選択中
        this.cellSelectStatus++; // 2にする
        if (cell.text === '' && this.cellSelectStatus === 2) {
          // 編集可能にする
          cell.edit = true;
        }
      } else {
        this.cellSelectStatus = 0;
      }
    },
    inputCell: function inputCell(_ref) {
      var type = _ref.type,
          target = _ref.target;
      // textの入力を取得
      var width = (target.value.length + 1) * 8 + 'px';
      target.style.width = width;
      target.parentNode.style.width = width;
    },
    submit: function submit(cell) {
      cell.edit = !cell.edit;
    },
    copyToClipBoard: function copyToClipBoard() {
      var target = document.querySelector('#mdArea');
      var range = document.createRange();
      range.selectNode(target);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      this.$message({
        message: 'Copy Success',
        type: 'success',
        duration: 1000
      });
    }
  },
  directives: {
    focus: focus
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.75cf065ced21c02c9f1d.js